<template>
	<div class="order-center">
		<div class="container">
			<div class="status-list">
				<div class="status-item" v-for="(v,k) in status_list" :key="`s`+k" :class="{active:form_data.status===k}" @click="change_status(k)">
					{{v.name}} <template v-if="v.count>0||true">({{v.count}})</template>
				</div>
				<div class="search">
					<img src="../../assets/images/icon-search.png" alt="" class="icon-search">
					<input type="text" placeholder="search" v-model="form_data.keyword" class="input" @keyup.enter="search">
				</div>
			</div>

			<template v-if="order_list.length>0">
				<div class="list">
					<div class="item">
						<div class="th">
							<div class="info">Product Information</div>
							<div class="quantity">Quantity</div>
							<div class="amount">Order Amount</div>
							<div class="status">Order Status</div>
							<div class="status">Production Status</div>
							<div class="action">Action</div>
						</div>
					</div>
					<div class="item td" v-for="(v,k) in order_list"  :key="`or`+k" @click="go2detail(v.uuid)">
						<div class="title">
							Order No.：{{v.order_no}}
						</div>
						<div class="content td">
							<div class="info" >
								<div v-for="(vv, kk) in v.mtms" class="sub-info">
									<div class="left">
										<img :src="vv.design_data.category.image|default_img" alt="" class="image">
									</div>
									<div class="right">
										<div class="sub-name">{{vv.design_data.category.style_no}}</div>
										<div class="sub-category">Category：{{vv.design_data.category.product_category_name}}</div>
										<div class="sub-size">Size：{{vv.spec_info.join('，')}}</div>
										<div class="sub-quantity">Quantity：{{vv.quantity}}</div>
									</div>
								</div>
							</div>
							<div class="quantity">
								×{{v.quantity}}
							</div>
							<div class="amount">
								${{v.total_price}}
							</div>
							<div class="status" :class="oc(v)">
								{{v.status_name}}
							</div>
              <div class="status">
                <div v-if="v.mtms.length > 1">
                  <p v-for="(vv, kk) in v.mtms" :key="kk">{{ vv.po_no }}:{{ vv.center_status }}</p>
                </div>
                <div v-else>
                  <p  v-for="(vv, kk) in v.mtms"  :key="kk" >{{ vv.center_status }}</p>
                </div>
								
							</div>
							<div class="action">
								<div class="btn btn-pay" v-if="v.status_text === 'unpaid'" @click.stop="pay(v.uuid)">Pay Now</div>
								<div class="btn btn-pay" v-if="v.need_makeup" @click.stop="open_makeup_modal(v.uuid)">Pay Now</div>
								<div class="btn btn-pay" v-if="v.status_text === 'unpaid'" @click.stop="cancel(v.uuid)">Cancel Order</div>
								<div class="btn btn-pay" v-if="v.status_text === 'wait_confirm'" @click.stop="confirm(v.uuid)">Confirm Receipt</div>
								<div class="btn btn-pay" v-if="v.status_text === 'wait_delivery' && v.is_need_send_back && !v.self_send" @click.stop="onSubMeterials(v.uuid)">Send Materials</div>
								<div class="btn-customer" @click.stop="showChat(v)">
									<img src="../../assets/images/chat/chat-icon.png" style="width:25px;height:25px;" />
								</div>
							</div>
						</div>

					</div>
				</div>
				<Page :current="page" :page-size="size"  :total="total" @on-change="changePage" show-total style="margin-top: 20px;"  show-sizer @on-page-size-change="changeSize" :page-size-opts="[5, 10, 20]"></Page>
			</template>
			<template v-else>
				<img src="../../assets/images/no-data.png" style="width:300px;display: block;margin:0 auto;" alt="">
			</template>

			<popup :show.sync="is_popup_show" width="490px" height="320px" @on-close="close">
				<h2>Fill in Logistics Number</h2>
				<div class="form">
					<div class="form-group">
						<div class="form-label">Courier Name:</div>
						<div class="form-control">
							<select class="input" placeholder="Please enter courier name" v-model="form_data_send.logistics_name" >
								<option value="">Please Select</option>
								<option value="SF Express">SF Express</option>
								<option value="JD Express">JD Express</option>
								<option value="STO Express">STO Express</option>
								<option value="YTO Express">YTO Express</option>
								<option value="Yunda Express">Yunda Express</option>
								<option value="DBL Express">DBL Express</option>
								<option value="ZTO Express">ZTO Express</option>
								<option value="Postal EMS">Postal EMS</option>
								<option value="J&T Express">J&T Express</option>
								<option value="Best Express">Best Express</option>
								<option value="UC Express">UC Express</option>
								<option value="AAE Global">AAE Global</option>
								<option value="ANE Logistics">ANE Logistics</option>
								<option value="Other">Other</option>
							</select>
						</div>
					</div>
					<div class="form-group">
						<div class="form-label">Tracking Number:</div>
						<div class="form-control">
							<input type="text" class="input" placeholder="Please enter tracking number" v-model="form_data_send.logistics_no" />
						</div>
					</div>
					<div class="btn-submit" @click="save">Save</div>
				</div>
			</popup>

			<popup :show.sync="is_popup_show2" width="490px" height="250px" @on-close="close_makeup_modal">
				<h2>How Would You Pay</h2>
				<div class="form">
					<div class="form-group">
						<div class="form-label">By</div>
						<div class="form-control">
							<select class="input" placeholder="Please enter courier name" v-model="form_data_makeup.pay_type" >
								<option value="paypal">Paypal</option>
								<option value="credit">Credit</option>
							</select>
						</div>
					</div>
					<div class="btn-submit" @click="makeup">Pay</div>
				</div>
			</popup>

			<!-- <img src="../../assets/images/icon-customer-info-detail.png" alt="" class="customer" @click="$refs.chat.showChat()"> -->
			<Chat ref="chat"></Chat>
		</div>
	</div>
</template>

<script>
import axios from "axios";
import {
  Profile,
  OrderList,
  OrderCount,
  ConfirmOrder,
  CancelOrder,
  SendFabric,
} from "@/api/index.js";
import Popup from "@/components/Popup.vue";
const form_data_send = {
  logistics_name: "",
  logistics_no: "",
  uuid: "",
};
export default {
  name: "OrderCenter",
  components: {
    Popup,
  },
  data() {
    return {
      size: 10,
      page: 1,
      total: -1,
      form_data: {
        keyword: "",
        status: "all",
      },
      status_list: {
        all: { name: "All Orders", value: "all", count: 0 },
        wait_pay: { name: "Pending Payment", value: "wait_pay", count: 0 },
        wait_delivery: {
          name: "Pending Shipment",
          value: "wait_delivery",
          count: 0,
        },
        wait_confirm: {
          name: "Pending Receipt",
          value: "wait_confirm",
          count: 0,
        },
        complete: { name: "Completed", value: "complete", count: 0 },
        cancel: { name: "Cancel", value: "cancel", count: 0 },
      },
      order_list: [],
      is_popup_show: false,
      form_data_send: { ...form_data_send },
      is_popup_show2: false,
      form_data_makeup: {
        uuid: "",
        pay_type: "paypal",
      },
    };
  },
  watch: {
    "form_data.status": function(newVal, oldVal) {
      this.form_data.status = newVal;
      this.page = 1;
      this.getOrderList();
    },
  },
  computed: {
    avatar() {
      return this.profile.avatar || require("@/assets/images/avatar.png");
    },
  },
  mounted() {
    this.change_status("all");
    axios
      .all([this.getProfile(), this.getOrderList()])
      .then(axios.spread(() => {}));
  },
  methods: {
    showChat(v) {
      this.$refs.chat.showChat({
        uuid: v.uuid, //订单uuid
        image: v.mtms[0].design_data.category.image || v.design.image ,
        name: v.mtms[0].design_data.category.style_no || v.design.style_no,
        from: "order",
      });
    },
    open_makeup_modal(uuid) {
      this.is_popup_show2 = true;
      this.form_data_makeup.uuid = uuid;
    },
    close_makeup_modal() {
      this.is_popup_show2 = false;
      this.form_data_makeup = { uuid: "", pay_type: "paypal" };
    },
    makeup() {
      this.$router.push({
        name: "Makeup",
        query: {
          uuid: this.form_data_makeup.uuid,
          pay_type: this.form_data_makeup.pay_type,
        },
      });
    },
    save() {
      SendFabric(this.form_data_send)
        .then(() => {
          this.$layer.msg(`Saved successfully`);
          this.is_popup_show = false;
          this.form_data_send = { ...form_data_send };
          return this.getOrderList();
        })
        .catch((res) => {
          this.$layer.msg(res.msg);
        });
    },
    close() {
      this.is_popup_show = false;
    },
    onSubMeterials(uuid) {
      this.form_data_send.uuid = uuid;
      this.is_popup_show = true;
    },
    search() {
      this.getOrderList();
    },
    confirm(uuid) {
      this.$DModal.confirm({
        content: "Confirm receipt of this order?",
        okText: "Confirm",
        cancelText: "Cancel",
        onOK: () => {
          ConfirmOrder({ uuid })
            .then(() => {
              this.$layer.msg(`Operation successful`);
            })
            .finally(() => {
              this.getOrderList();
            });
        },
      });
    },
    cancel(uuid) {
      this.$DModal.confirm({
        content: "Are you sure you want to cancel this order?",
        okText: "Confirm",
        cancelText: "Cancel",
        onOK: () => {
          CancelOrder({ uuid })
            .then(() => {
              this.$layer.msg(`Operation successful`);
            })
            .finally(() => {
              this.getOrderList();
            });
        },
      });
    },
    pay(uuid) {
      this.$router.push({
        name: "WorkBenchCheckout",
        query: { uuid },
      });
      // this.$router.push({name: 'CashDesk', query: {uuid, pay_type: 'wechat'}})
    },
    oc(v) {
      return [v.status_text];
    },
    go2detail(uuid) {
      this.$router.push({ name: "OrderDetail", query: { uuid } });
    },
    changePage(page) {
      this.page = page;
      this.getOrderList();
    },
    changeSize(size) {
      this.page = 1;
      this.size = size;
      this.getOrderList();
    },
    change_status(s) {
      this.form_data.status = s;
    },
    async getProfile() {
      return Profile().then((response) => {
        return response;
      });
    },
    async getOrderList() {
      this.order_list = [];
      return OrderList({ ...this.form_data, page: this.page, size: this.size })
        .then((response) => {
          this.order_list = response.data.list;
          this.total = response.data.total;
          return OrderCount(this.form_data);
        })
        .then((response) => {
          for (let code in response.data) {
            this.status_list[code].count = response.data[code];
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.order-center {
  width: 100%;
  .container {
    padding: 0 70px 0 30px;
    background: white;

    .status-list {
      position: relative;
      padding: 30px 0;
      display: flex;
      align-content: center;
      .status-item {
        margin: 0 14px;
        // width: 90px;
        height: 35px;
        line-height: 35px;
        font-size: 14px;
        text-align: center;
        cursor: pointer;
        padding: 0 10px;
        &.active {
          background: #fa3d5a;
          border-radius: 5px;
          color: white;
        }
        &:first-child {
          margin-left: 0;
        }
      }
      .search {
        position: absolute;
        top: 23px;
        right: 0;
        .icon-search {
          position: absolute;
          top: 15px;
          left: 20px;
          width: 20px;
          height: 20px;
        }
        .input {
          width: 260px;
          height: 50px;
          line-height: 50px;
          border-radius: 25px;
          padding-left: 50px;
          background: #f3f4f6;
          font-size: 14px;
          outline: none;
          border: none;
        }
      }
    }

    .list {
      padding: 10px 0;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      .item {
        // width: 1500px;
        width: 100%;
        margin: 5px 0;
        background: #ffffff;
        border-radius: 10px 10px 10px 10px;
        border: 1px solid #ebedf2;
        cursor: pointer;
        color: #191a1c;
        .title {
          height: 42px;
          line-height: 42px;
          padding-left: 20px;
          color: #191a1c;
          background: #edeff2;
        }
        .th {
          display: flex;
          flex-wrap: nowrap;
          line-height: 52px;
          text-align: center;
          background: #f6f7fa;
          border-radius: 5px 5px 0px 0px;
          border: 1px solid #e3e3e3;
          color: #575859;
          font-size: 14px;
          .info {
            width: 730px;
          }
          .quantity {
            width: 200px;
          }
          .amount {
            width: 200px;
          }
          .status {
            width: 200px;
          }
          .action {
            width: 200px;
          }
        }
        .content {
          display: flex;
          flex-wrap: nowrap;
          text-align: center;
          align-items: center;
          .info {
            width: 730px;
            border-right: 1px solid #e3e3e3;
            .sub-info {
              display: flex;
              height: 150px;
              padding: 10px;
              .left {
                .image {
                  width: 110px;
                  height: 110px;
                  object-fit: cover;
                }
              }
              .right {
                text-align: left;
                padding: 10px;
                display: flex;
                flex-wrap: wrap;
                justify-content: flex-start;
                .sub-name {
                  width: 100%;
                  color: #191a1c;
                  font-size: 14px;
                  font-weight: 500;
                }
                .sub-category {
                  width: 100%;
                  color: #666;
                  font-size: 14px;
                }
                .sub-size {
                  width: 100%;
                  color: #666;
                }
                .sub-quantity {
                  width: 100%;
                  color: #666;
                }
              }
            }
          }
          .quantity {
            width: 200px;
            line-height: 150px;
            border-right: 1px solid #e3e3e3;
          }
          .amount {
            width: 200px;
            line-height: 150px;
            border-right: 1px solid #e3e3e3;
            font-weight: bold;
            font-size: 14px;
          }
          .status {
            width: 200px;
            line-height: 150px;
            border-right: 1px solid #e3e3e3;
            font-size: 14px;
            &.unpaid {
              color: #ff4400;
            }
            &.wait_delivery {
              color: #1572b8;
            }
            &.wait_confirm {
              color: #32a410;
            }
            &.cancel {
              color: #666666;
            }
            &.complete {
              color: #666666;
            }
          }
          .action {
            width: 200px;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            row-gap: 5px;
            .btn {
              width: 80px;
              height: 35px;
              line-height: 35px;
              text-align: center;
              border-radius: 5px;
              font-size: 14px;
              margin: 0 5px;
              &.btn-pay {
                background: #fa3d5a;
                color: white;
              }
            }
            .btn-customer {
              color: #3c3c3c;
              font-size: 14px;
            }
          }
        }
      }
    }
  }
}
::v-deep .popup-modal {
  h2 {
    padding: 10px 20px;
    color: #333333;
    font-size: 18px;
    font-weight: bold;
    border-bottom: 1px solid #f0f0f0;
  }
  .form {
    padding: 10px 0;
    .form-group {
      display: flex;
      flex-wrap: wrap;
      justify-content: left;
      align-items: center;
      margin-top: 20px;
      .form-label {
        width: 100px;
        font-size: 14px;
        color: #696a6a;
        text-align: right;
      }
      .form-control {
        position: relative;
        .input {
          width: 300px;
          height: 48px;
          line-height: 48px;
          border: 1px solid #d9d9d9;
          border-radius: 5px;
          padding: 0 10px;
          outline: none;
          font-size: 14px;
          &[readonly] {
            border: none;
          }
        }
      }
    }

    .btn-submit {
      margin: 40px 0 0 40px;
      width: 110px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: #fa3d5a;
      color: white;
      border-radius: 6px;
      cursor: pointer;
    }
  }
}

.customer {
  width: 50px;
  height: 50px;
  position: fixed;
  right: 20px;
  bottom: 200px;
  cursor: pointer;
}
</style>
